//export { default } from './Expo';
import Index2 from './MainView';

export default {
    path: '/',
    component: Index2
}
